import { render, staticRenderFns } from "./LoginSection2.vue?vue&type=template&id=5ebf8de3"
import script from "./LoginSection2.vue?vue&type=script&lang=js"
export * from "./LoginSection2.vue?vue&type=script&lang=js"
import style0 from "./LoginSection2.vue?vue&type=style&index=0&id=5ebf8de3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports